export const redirect = (vueRouter: any) => (route: string, external = false, preserveHistory = false) => {
  if (!external) {
    vueRouter.push({ name: route })
    return
  }

  if (preserveHistory) {
    // the user WILL be able to use the back button to navigate to the current page after redirection.
    window.location.href = route
    return
  }

  // the user WON'T be able to use the back button to navigate to the current page after redirection.
  window.location.replace(route)
}
